import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-25a7f6bb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex h-[60px] text-[16px] flex-row justify-between px-4 py-4 bg-gray-900 text-white" }
const _hoisted_2 = { class: "flex flex-row items-center space-x-4" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "hidden sm:inline" }, "STOCKMARKET.club", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "inline text-xs sm:hidden" }, "Stockmarket.club", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "hidden sm:inline" }, "Courses", -1))
const _hoisted_6 = { class: "flex flex-row items-center space-x-4" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "hidden sm:inline" }, "Pro", -1))
const _hoisted_8 = {
  key: 0,
  class: "mr-4"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "hidden sm:inline" }, "Login", -1))
const _hoisted_10 = { key: 0 }

import { SunIcon, MoonIcon, FireIcon, BookOpenIcon, UserCircleIcon } from '@heroicons/vue/24/solid'
import { ref, watch } from "vue";
import LoginComponent from "@/components/LoginComponent.vue";
import { useUserStore } from "@/stores/userStore";
import { storeToRefs } from "pinia";
import ProfileIconComponent from "@/components/ProfileIconComponent.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'NavBar',
  setup(__props) {

const isLoggedIn = ref(false)
const userStore = useUserStore();

const { userState, plan } = storeToRefs(userStore)
isLoggedIn.value = !!userState.value

let isPro = ref(false);

if (plan.value && plan.value?.expiry_date) {
  isPro.value = plan.value?.expiry_date.toDate() > new Date();
}

watch(plan, (newVal) => {
  isPro.value = newVal?.expiry_date.toDate() > new Date();
});

watch(userState, (newVal) => {
  isLoggedIn.value = !!newVal
});

const darkMode = ref(false)
const showLoginDialog = ref(false)

const toggleDarkMode = () => {
  darkMode.value = !darkMode.value
  document.body.classList.toggle('dark-theme')
  if (darkMode.value) {
    localStorage.setItem('theme', 'dark')
  } else {
    localStorage.setItem('theme', 'light')
  }
}

if (localStorage.getItem('theme') === 'dark') {
  darkMode.value = true
  document.body.classList.add('dark-theme')
} else {
  darkMode.value = false
  document.body.classList.remove('dark-theme')
}

const onOpenLoginDialog = () => {
  showLoginDialog.value = true
}

const onCloseLoginDialog = () => {
  showLoginDialog.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_link, {
          to: "/",
          class: "font-bold text-xl inline-flex items-left justify-center space-x-1 py-1 px-1 rounded-full transition-colors duration-300 text-transparent bg-clip-text bg-gradient-to-r from-pink-500 to-yellow-500"
        }, {
          default: _withCtx(() => [
            _hoisted_3,
            _hoisted_4
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/courses",
          class: _normalizeClass([{
                      'font-bold bg-gray-700 text-white': _ctx.$route.path === '/courses',
                      'hover:bg-gray-600': _ctx.$route.path !== '/courses'
                   }, "font-bold items-center justify-center px-3 py-1 rounded-full transition-colors duration-300"])
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BookOpenIcon), { class: "h-6 w-6 inline sm:hidden" }),
            _hoisted_5
          ]),
          _: 1
        }, 8, ["class"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_router_link, {
          to: "/pro",
          class: "font-bold hover:bg-gray-700 text-white text-[16px] inline-flex items-center justify-center space-x-1 py-1 px-3 rounded-full transition-colors duration-300"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(FireIcon), { class: "h-6 w-6" }),
            _hoisted_7
          ]),
          _: 1
        }),
        _createElementVNode("button", {
          class: "hover:bg-gray-700 p-2 rounded-full transition-colors duration-300",
          onClick: toggleDarkMode
        }, [
          (darkMode.value)
            ? (_openBlock(), _createBlock(_unref(SunIcon), {
                key: 0,
                class: "h-6 w-6"
              }))
            : (_openBlock(), _createBlock(_unref(MoonIcon), {
                key: 1,
                class: "h-6 w-6"
              }))
        ]),
        (isLoggedIn.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createVNode(ProfileIconComponent, { user: _unref(userState) }, null, 8, ["user"])
            ]))
          : _createCommentVNode("", true),
        (!isLoggedIn.value)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              id: "login-button",
              onClick: onOpenLoginDialog,
              class: "font-bold text-white transition-colors duration-300 hover:bg-gray-700 hover:text-white p-2 rounded-full"
            }, [
              _createVNode(_unref(UserCircleIcon), { class: "h-6 w-6 inline sm:hidden" }),
              _hoisted_9
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (showLoginDialog.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createVNode(LoginComponent, { "on-close": onCloseLoginDialog })
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})